import { createStore } from "vuex";
import apiBase from "../services/api/apiBase";
import cart from "./modules/cart";
import ui from "./modules/ui";
import logos from "./modules/logos";
import customizations from "./modules/customizations";
import search from "./modules/search";
import createPersistedState from "vuex-persistedstate";
import { getUser, loginUser } from "@/services/api";

export default createStore({
  state: {
    registration: {
      name: "",
      email: "",
      password: "",
    },
    user: {},
    activeProfile: "Maker",
    theme: "dark",
  },
  mutations: {
    setRegistration(state, payload) {
      state.registration = payload;
    },
    setUser(state, user) {
      state.user = user;
    },
    setRegisterConfirmed(state, value) {
      state.user = {
        ...state.user,
        registerConfirmed: value,
      };
    },
    setActiveProfile(state, profile) {
      state.activeProfile = profile;
    },
    setTheme(state, theme) {
      state.theme = theme;
    },
  },
  actions: {
    async loginUser(_, { email, password }) {
      const data = (await loginUser(email, password)).data;
      const token = data.access_token;
      localStorage.setItem("token", token);
      await this.dispatch("loginUserByToken", token);
    },

    async loginUserByToken({ commit, dispatch }, token) {
      apiBase.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      const resp = await getUser();
      const user = resp.data;
      commit("setUser", user);
      try {
        await dispatch("cart/fetchSummary", null, { root: true });
      } catch (e) {
        // logue e siga a vida; token continua válido
        console.warn("Erro ao buscar os dados do carrinho:", e);
      }

      return user;
    },
    async logout({ commit }) {
      delete apiBase.defaults.headers.common["Authorization"];
      localStorage.removeItem("token");
      commit("setUser", {});
      commit("cart/RESET_CART", null, { root: true });
      commit("customizations/RESET_CUSTOMIZATIONS", null, { root: true });
      commit("logos/RESET_LOGOS", null, { root: true });
    },
    toggleTheme({ commit, state }) {
      const newTheme = state.theme === "dark" ? "light" : "dark";
      commit("setTheme", newTheme);
    },
  },
  getters: {
    registrationData: (state) => state.registration,
    activeProfile: (state) => state.activeProfile,
  },
  modules: {
    cart,
    ui,
    logos,
    customizations,
    search,
  },
  plugins: [
    createPersistedState({
      key: "mm:ps",
      // persista apenas o que precisa sobreviver ao reload
      paths: [
        "theme",
        "activeProfile",
        "cart.summary", // badge persiste (não o módulo inteiro)
        "logos",
        "customizations",
      ],
    }),
  ],
});
